export default __webpack_public_path__ + "static/media/InstantWithdrawals.635919ac.png";